// Footer.jsx
import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-yellow-light text-center py-4">
      <p className="text-black text-sm">&copy; 2024 cerise. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
